export default __webpack_public_path__ + "static/media/one-point-jump.744784f4.yaml";